import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Carousel from 'react-bootstrap/Carousel';
import './screenshot.css'

const index = () => {
    return (
        <>
            <section>
                <Container>
                    <Row>
                        <Col></Col>
                        <Col>
                            {/* <div className='frame-container'>
                                <img className='frame' src='img/screenshot-bg.jpg' />
                                <div className='tilt active'><img src='https://s3.amazonaws.com/randomBucket/ScreeshotDemo/step1.png' /></div>
                                <div className='tilt'><img src='https://s3.amazonaws.com/randomBucket/ScreeshotDemo/step2.png' /></div>
                                <div className='tilt'><img src='https://s3.amazonaws.com/randomBucket/ScreeshotDemo/step3.png' /></div>
                                <div className='tilt'><img src='https://s3.amazonaws.com/randomBucket/ScreeshotDemo/step4.png' /></div>
                            </div> */}

                            {/* <Carousel data-bs-theme="dark">
                                <Carousel.Item>
                                    <img
                                        className="d-block"
                                        src="img/1.jpg"
                                        alt="First slide"
                                    />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <img
                                        className="d-block"
                                        src="img/2.jpg"
                                        alt="Second slide"
                                    />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <img
                                        className="d-block"
                                        src="img/3.jpg"
                                        alt="Third slide"
                                    />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <img
                                        className="d-block"
                                        src="img/4.jpg"
                                        alt="Third slide"
                                    />
                                </Carousel.Item>
                            </Carousel> */}

                        </Col>
                        <Col></Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

// $(function () {
//     var $tilts = $('.tilt');
//     var $last = $tilts.first();
//     var count = 0;
//     setInterval(function () {
//         // Move all tilts to the back
//         $tilts.css('z-index', '0');

//         // Select current tilt
//         var $tilt = $tilts.eq(++count % $tilts.length);

//         // Keep last tilt on front
//         $last.css('z-index', '1');

//         // Fade current tilt
//         $tilt
//             .hide()
//             .css('z-index', '2')
//             .fadeIn(400);

//         // Save last tilt
//         $last = $tilt;
//     }, 2000);
// })
export default index
